import type { RouteObject } from 'react-router-dom';

import { values } from 'lodash-es';

import { 매니저_라우터 } from '.';
import { 공지사항_페이지_라우터 } from './notice-setting/공지사항_라우터';
import { 영업_페이지_라우터 } from './영업/영업_라우터';

export const managerRoutes: RouteObject = {
  async lazy() {
    const { default: Layout } = await import('./ManagerRouteLayout');
    return {
      Component: Layout,
    };
  },
  children: [...values(매니저_라우터), ...values(공지사항_페이지_라우터), ...values(영업_페이지_라우터)],
};
